import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default function WachtwoordVergetenPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      setError('Vul een geldig emailadres in');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const apiBase = process.env.REACT_APP_BACKEND_URL;
      await axios.post(`${apiBase}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (e) {
      setError('Er ging iets mis, probeer opnieuw');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md" data-testid="wachtwoord-vergeten-page">
        <div className="bg-white shadow-sm border border-gray-100">
          <div className="px-7 py-6 border-b border-gray-100">
            <h1 className="text-2xl font-bold text-gray-900">Wachtwoord vergeten?</h1>
            <p className="text-sm text-gray-600 mt-1">We sturen je een reset-link via email (1 uur geldig).</p>
          </div>

          <div className="px-7 py-6">
            {sent ? (
              <div className="text-center space-y-4" data-testid="wachtwoord-vergeten-success">
                <div className="text-5xl">📧</div>
                <p className="text-sm text-gray-700">
                  Als er een account bestaat met dit emailadres, ontvang je binnen enkele minuten een reset-link.
                </p>
                <p className="text-xs text-gray-500">
                  Geen email ontvangen? Check je spam-map of vraag een nieuwe link aan.
                </p>
                <div className="pt-2">
                  <Link to="/login" className="text-sm text-[#002FA7] font-semibold hover:underline" data-testid="wachtwoord-vergeten-naar-login">
                    ← Terug naar inloggen
                  </Link>
                </div>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="field-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="jij@bedrijf.be"
                    autoComplete="email"
                    autoFocus
                    data-testid="wachtwoord-vergeten-email"
                  />
                </div>
                {error && (
                  <div className="p-3 bg-red-50 border border-red-200 text-red-600 text-sm" data-testid="wachtwoord-vergeten-error">
                    {error}
                  </div>
                )}
                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-primary w-full justify-center"
                  data-testid="wachtwoord-vergeten-submit"
                >
                  {loading ? 'Versturen...' : 'Reset-link versturen'}
                </button>
                <div className="text-center pt-2">
                  <Link to="/login" className="text-xs text-gray-500 hover:text-[#002FA7]" data-testid="wachtwoord-vergeten-cancel">
                    ← Terug naar inloggen
                  </Link>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
